module.exports = __webpack_public_path__ + "img/children-potatoes-1.75431ee0.jpg";